<div class="d-flex" id="wrapper">

  <admin-sidebar></admin-sidebar>

  <div id="page-content-wrapper">

    <admin-navigation></admin-navigation>

    <div class="container-fluid">
      <h3 class="mt-5 mt-md-5 mb-5 mb-md-5 font-weight-bold page-title">Dashboard</h3>

      <div class="text-right">
        <div class="btn-group btn-group-toggle" data-toggle="buttons">
          <label class="btn btn-secondary">
            <input type="radio" name="options" id="option1" autocomplete="off" (click)="lastWeek()">
            <i class="fa fa-angle-left"></i>
          </label>
          <label class="btn disable-white">
            <input type="radio" name="options" id="option2" autocomplete="off" checked> {{ today }}
          </label>
          <label class="btn btn-secondary">
            <input type="radio" name="options" id="option3" autocomplete="off" (click)="nextWeek()">
            <i class="fa fa-angle-right"></i>
          </label>
        </div>
      </div><br/>

      <div class="row">
        <div class="col-md-4">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Weekly Users</h4>
              <p class="card-text font-weight-bold">
                <canvas id="canvas-users">{{ chartUsers }}</canvas>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Weekly Organisations</h4>
              <p class="card-text font-weight-bold">
                <canvas id="canvas-organisations">{{ chartOrganisations }}</canvas>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Weekly Revenue</h4>
              <p class="card-text font-weight-bold">
                <canvas id="canvas-revenue">{{ chartRevenues }}</canvas>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="card">
            <div class="card-body text-center">
              <h5 class="card-title">Breath training active users</h5>
              <p class="card-text font-weight-bold">
                <select class="form-control" (change)="changeOrg()" [(ngModel)]="organisationVal">
                 
                  <option value="{{org.key}}" *ngFor="let org of organisations">{{org.value}}</option>
                </select>
              </p>
              <h1>
                {{ active_users_percentage }}%
              </h1>
              <p>
                ( out of {{ total_users }} users )
              </p>
            </div>
          </div>
        </div>
      </div>


    </div>

    <!-- Modal Loader -->
    <modal-loader [modalText]="modalText"></modal-loader>

  </div>
</div>
